var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fieldset", { staticClass: "spa-terms-and-conditions" }, [
    _c("legend", { staticClass: "sr-only" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.tc("spaSoft.step2.termsAndConditionsLinkLabel")) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "spa-terms-and-conditions__list",
      domProps: { innerHTML: _vm._s(_vm.propertyData.checkoutPolicies) },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "flex-grid-1-col gutter-md terms-wrapper" }, [
      _c("div", { staticClass: "input checkbox" }, [
        _c("label", { staticClass: "spa-terms-and-conditions__terms-label" }, [
          _c("input", {
            attrs: {
              id: "termsAndConditions",
              name: "termsAndConditions",
              type: "checkbox",
              "data-val": "true",
              required: "",
              "data-val-ischecked": _vm.tc("validations.ischecked"),
              "data-field-type": "CheckBoxSet",
            },
            on: { change: _vm.updateTermsAndConditionsValidationStatus },
          }),
          _vm._v(" "),
          _c("span", {
            domProps: { innerHTML: _vm._s(_vm.termsAndConditions) },
          }),
        ]),
        _vm._v(" "),
        _c("span", {
          staticClass: "field-validation-valid",
          attrs: {
            "data-valmsg-for": "termsAndConditions",
            "data-valmsg-replace": "true",
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }